
















import { Component, Vue } from 'vue-property-decorator';
import GameLogic, {Hotspot, HotspotOption} from "../services/GameLogic";
import ViewPortOverlay from "./ViewPortOverlay.vue";
import Viewport from '@/services/ScrollingViewport';
import PanningViewport from "../components/PanningViewport.vue";
import {DelierState} from "../store/store";

@Component({
    components: {PanningViewport, ViewPortOverlay},
    computed: {
        getRoomImage():string { return GameLogic.getRoomImage(this.$store.state); },
        getClockImage():string { return GameLogic.getClockImage(this.$store.state); },
        getWhiteboardImage():string { return GameLogic.getWhiteboardImage(this.$store.state); }
    },
    methods: {
        getObjectOverlayStyle(key:string):any {
            let pos = GameLogic.getRoomObjectPosition(this.$store.state, key);
            let style:any = GameLogic.getPositionStyle(pos, 1920, 1080);
            let scale:number = this.$store.state.viewportScale; //Viewport.getContentScale()
            style['transform'] = ['scale(', scale,', ', scale, ')'].join('');
            style['transform-origin'] = 'top left';
            //console.log('getObjectOverlayStyle', scale);// style
            return style;
        }
    },
    watch: {
        $route: function (val) {
            //console.log('new route: ', val.name);
            Viewport.setPause(val.name !== 'nurse' && val.name != 'morning');
            Viewport.setHide(val.name === 'patient');
        }
    }
})
export default class DayGame extends Vue {}
